import axios from "axios";
import { useContext } from "react";
import { IP } from "utils/Host"
import { TechnologyContext } from "context/TechnologyContext";
import { AppContext } from "context/AppContext";

export function useGant() {
  const techContext = useContext(TechnologyContext);
  const setGantStageGrupy = techContext.setGantStageGrupy;
  const gantStageGrupy = techContext.gantStageGrupy;
  const appContext = useContext(AppContext)
  const selectedProcesor = techContext.selectedProcesor
  const refreshGant = async (id) => {
    let procesor_id = id || 3;
    const res = await axios.get(
      IP + "gantGrupy/" + sessionStorage.getItem("token")
    );

    setGantStageGrupy(...[res.data.filter(x => x.procesor_id == procesor_id)]);

  };


  const refreshGantAll = async (id) => {
    let procesor_id = id || 3;
    const res = await axios.get(
      IP + "gantGrupy/" + sessionStorage.getItem("token")
    );

   
    setGantStageGrupy(...[res.data]);
  };


    const refreshGantZakonczone = async (zamowienie_id) => {
    const res = await axios.get(
      IP + "gantGrupyZakonczone/"+zamowienie_id+"/" + sessionStorage.getItem("token")
    );


   console.log("Zamowienie_id"+zamowienie_id)
   console.table(res.data)
    setGantStageGrupy((prev) => [...prev, ...res.data]);
  };




  return [refreshGant,refreshGantAll,refreshGantZakonczone];
}